{
    "Accessibility menu": "ადაპტირებული მენიუ",
    "Close": "დახურვა",
    "Text and Reading": "ტექსტი და კითხვა",
    "Navigation and Interaction": "ნავიგაცია და ინტერაქცია",
    "Text Align": "ტექსტის სწორება",
    "Align Left": "მარცხნივ გასწორება",
    "Align Center": "ცენტრში სწორება",
    "Align Right": "მარჯვნივ სწორება",
    "Adjust Font Size": "ფონტის ზომის მორგება",
    "Highlight Title": "სათაურების გამოყოფა",
    "Highlight Links": "ბმულების გამოყოფა",
    "Readable Font": "წაკითხვადი ფონტი",
    "Color and Contrast": "ფერი და კონტრასტი",
    "Dark Contrast": "მუქი კონტრასტი",
    "Light Contrast": "ღია კონტრასტი",
    "High Contrast": "მაღალი კონტრასტი",
    "High Saturation": "მაღალი გაჯერება",
    "Low Saturation": "დაბალი გაჯერება",
    "Monochrome": "ერთფეროვანი გამოსახულება",
    "Tools": "ხელსაწყოები",
    "Reading Guide": "კითხვის გამყოლი ზოლი",
    "Big Cursor": "დიდი კურსორი",
    "Increase Font Size": "ფონტის ზომის გაზრდა",
    "Decrease Font Size": "ფონტის ზომის შემცირება",
    "Letter Spacing": "ასოებს შორის დაშორება",
    "Line Height": "ხაზის სიმაღლე",
    "Font Weight": "ფონტის წონა",
    "Dyslexia Font": "დისლექსიური ფონტი",
    "Language": "ენა",
    "Accessibility widget": "გახსენი ადაპტირებული მენიუ",
    "Accessibility Profiles": "ადაპტირებული პროფილები",
    "Cognitive Disability": "კოგნიტიური შეზღუდვა",
    "Seizure Safe": "უსაფრთხო ეპილეფსიისთვის",
    "Accessibility statement": "ადაპტირების დეკლარაცია",
    "ADHD": "ADHD",
    "Low Vision": "დაქვეითებული მხედველობა",
    "Pause Animations": "ანიმაციების გაჩერება",
    "Animation paused": "ანიმაცია შეჩერებულია",
    "Reset all settings": "პარამეტრების დაბრუნება",
    "Shortcut:": "მალსახმობი:",
    "Epilepsy Safe Mode": "ეპილეფსიისთვის უსაფრთხო რეჟიმი",
    "Mute sounds": "ხმის დადუმება",
    "Page read": "გვერდის წაკითხვა",
    "Page read controls": "გვერდის წაკითხვის მართვა",
    "Pause": "პაუზა",
    "Resume": "გაგრძელება",
    "Stop": "შეჩერება",
    "Settings": "პარამეტრები",
    "Speed": "სიჩქარე",
    "Voice": "ხმა",
    "Close accessibility menu": "ხელმისაწვდომობის მენიუს დახურვა",
    "Back to accessibility menu": "ხელმისაწვდომობის მენიუში დაბრუნება",
    "Search languages": "ენების ძიება",
    "Selected language": "არჩეული ენა",
    "View accessibility statement (opens in new window)": "ხელმისაწვდომობის განცხადების ნახვა (იხსნება ახალ ფანჯარაში)",
    "Visit CookieYes website (opens in new window)": "CookieYes-ის ვებსაიტის მონახულება (იხსნება ახალ ფანჯარაში)",
    "Reset all accessibility settings to default": "ხელმისაწვდომობის ყველა პარამეტრის ნაგულისხმევზე დაბრუნება"
}
